"use strict";
exports.__esModule = true;
exports.toSlice = void 0;
var utils_1 = require("@lglp/utils");
var fields_1 = require("../fields");
var toSlice = function (data, type) {
    var _a;
    return utils_1.compact({
        type: type,
        enabled: fields_1.toBoolean((_a = data.primary) === null || _a === void 0 ? void 0 : _a.enabled, { defaultValue: true })
    });
};
exports.toSlice = toSlice;
//# sourceMappingURL=slice.js.map